
import React, { FC } from 'react';
import { LinearGradient, LinearGradientProps } from 'expo-linear-gradient';
import styled from '@emotion/native';


const Container = styled(LinearGradient)`
  flex-direction: row;
  justify-content: space-between;
  padding: 6px 9px;
  margin-bottom: 3px;
`;

type Props = LinearGradientProps & {};

const Header: FC<Props> = ({ ...props }) => {
  return (<Container {...props} />);
};

export default Header;